export default "__VITE_ASSET__6cf02409__"